import { onMount } from "solid-js";
import { useApplication } from "@/context/app";
import { useConfirmer } from "@/context/confirmer";
import { NewAppointment } from "../appointment/new";
import { CurrentAppointment } from "./current";
import { ListControl } from "../../components/ui/list/ListControl";
import { ListView } from "../../components/ui/list/ListView";
import AppointmentRow from "./row";
import { For } from "solid-js";
import useHome from "../../services/useHome";

export default function Home() {
  const { setBreadcrumb } = useApplication();
  const { showConfirmer } = useConfirmer();

  const { currentAppointments, onFetch } = useHome();

  let listRef;

  const refreshAll = async () => {
    await onFetch();
    listRef?.refresh();
  };

  const handleCurrentAction = (action, key) => {
    showConfirmer(action.url, [key], action.title, action.message, refreshAll, action.button, action.confirm, action.text);
  };

  onMount(async () => {
    setBreadcrumb([
      {
        name: "Home",
        current: true,
      },
    ]);

    await onFetch();
  });

  return (
    <div class="w-full">
      <div class="flex justify-between">
        <h1 class="py-2 text-lg">Today Appointments</h1>
        <NewAppointment onSaved={refreshAll} />
      </div>
      <div>
        <h3 class="py-2 text-md">Current Appointments</h3>
        <div class="grid grid-cols-9 gap-x-2">
          <For each={currentAppointments()}>
            {(appointment) => (
              <div class="col-span-3">
                <CurrentAppointment appointment={appointment} onAction={handleCurrentAction} />
              </div>
            )}
          </For>
        </div>
      </div>
      <div>
        <h3 class="py-2 mt-4 text-md">Upcoming Appointments</h3>
        <ListControl
          ref={(r) => { listRef = r; }}
          onAfterAction={onFetch}
          mode="list"
          search={false}
          actions={[]}
          filters={[]}
          sort={false}
          pagination={false}
          datasource={{
            type: "remote",
            config: {
              url: "/home/upcoming",
              method: "GET",
              params: {},
            },
          }}
          contentLoading={false}
        >
          {(innerProps) => (
            <ListView
              view="grid"
              grid="grid-cols-3"
              {...innerProps}
              template={AppointmentRow}
              placeholder={false}
            />
          )}
        </ListControl>
      </div>
    </div>
  );
}
